<template>
  <v-container fluid>
    <template v-if="comments.length > 0">
      <v-row>
        <v-col>
          <h3 class="thoughts text-left">
            {{comments.length}}
            {{comments.length === 1 ? 'thought' : 'thoughts'}}
            on "{{page.title}}"
          </h3>
        </v-col>
      </v-row>

      <comment-block
        v-for="(comment, index) in comments"
        :hide-divider="index == 0"
        :key="index"
        :comment="comment"
        @submitReply="onSubmitReply"
      ></comment-block>

      <v-divider></v-divider>
    </template>

    <template v-else>
      <v-row>
        <v-col>
          <h3>Thoughts on "{{page.title}}"</h3>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col>
          <p class="text-center">
            There are no comments on this post. Be the first one.
          </p>
        </v-col>
      </v-row>
    </template>

    <v-row>
      <v-col>
        <comment-form
          disable-cancel
          @submit="saveComment"
        ></comment-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  VCol,
  VContainer,
  VDivider,
  VRow,
} from 'vuetify/lib'

import CommentBlock from '@/components/CommentBlock'
import CommentForm from '@/components/CommentForm'
import { CommentDoc } from '@/utils/types'

export default {
  components: {
    CommentBlock,
    CommentForm,
    VCol,
    VContainer,
    VDivider,
    VRow,
  },
  computed: {},
  data: () => ({
    comments: [],
  }),
  methods: {
    onSubmitReply(reply) {
      CommentDoc
          .addReply(reply.commentId, reply.author, reply.email, reply.text)
          .then(() => {})
    },
    saveComment(comment) {
      CommentDoc.addComment(
        comment.author,
        comment.email,
        comment.rating,
        this.page.id,
        comment.text,
      ).then(() => {

      })
    },
  },
  created() {
    this.$bind(
        'comments',
        CommentDoc.listComments(this.page.id)
      ).then(() => {})
  },
  props: {
    page: Object,
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 22px;
  text-transform: none !important;
  text-align: left !important;
}
</style>
